import cn from 'classnames';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';

import {useState} from 'react';
import DotsLoading from '../../../../../../components/dotsLoading';
import {RootState} from '../../../../../../store/redux';
import {addRegisterStoreFormData} from '../../../../../../store/redux/registerStore';
import LabInputListCard from '../../labInputListCard';

const RegisterStoreLabBottomSheet = ({
  labBottomSheet,
  setLabBottomSheet,
  inputlists,
}: IregisterStoreLabBottomSheet) => {
  const navigate = useNavigate();
  const state = useSelector((state: RootState) => state.registerStore);

  const [selectedLabInputs, setSelectedLabInputs] = useState<Array<number>>([]);

  const dispatch = useDispatch();
  const handleSelect = (item: IInputLists) => {
    setSelectedLabInputs(prev => {
      if (selectedLabInputs.some(input => input === item.code)) {
        return selectedLabInputs.filter(input => input !== item.code);
      } else {
        return [...prev, item.code];
      }
    });
  };

  return (
    <BottomSheet
      onDismiss={() => setLabBottomSheet(false)}
      open={labBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col p-3">
        <span className="mb-4">
          انواع آزمایشات قابل ارائه در آزمایشگاه خود را انتخاب کنید.
        </span>
        {inputlists ? (
          <div className="grid grid-cols-2 gap-3">
            {inputlists?.map((item: IInputLists) => (
              <div
                className="flex flex-col"
                key={item.guid}
                onClick={() => handleSelect(item)}
              >
                <LabInputListCard
                  {...{item}}
                  active={selectedLabInputs.some(input => input === item.code)}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center h-full">
            <DotsLoading />
          </div>
        )}
        <section className="flex flex-1 h-12 gap-2 mt-4">
          <button
            className="flex flex-2 bg-white text-green-main justify-center items-center rounded border-[1px] border-green-main px-3"
            onClick={() => setLabBottomSheet(false)}
          >
            انصراف
          </button>
          <button
            className={cn(
              'flex flex-1  h-12 text-white bg-green-main justify-center items-center rounded',
              {' opacity-40': selectedLabInputs.length === 0},
            )}
            type="submit"
            disabled={selectedLabInputs.length === 0}
            onClick={() => {
              dispatch(
                addRegisterStoreFormData({
                  ...state,
                  lab_fields: selectedLabInputs,
                }),
              );
              setLabBottomSheet(false);
              navigate('/register-lab');
            }}
          >
            ادامه
          </button>
        </section>
      </div>
    </BottomSheet>
  );
};

export default RegisterStoreLabBottomSheet;
